import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import axios from 'axios';
import AlertMessage from "../../AlertMessage";
function EggandBananaRegisterBook() {
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  
  const [schoolData, setSchoolData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [countTotal1to5, setCountTotal1to5] = useState(0);
  const [countTotal6to8, setCountTotal6to8] = useState(0);
  const [selectedDate, setSelectedDate] = useState('');
  const [eggBeneficiary1to5, setEggBeneficiary1to5] = useState(0);
  const [eggBeneficiary6to8, setEggBeneficiary6to8] = useState(0);
  const [bananaBeneficiary1to5, setBananaBeneficiary1to5] = useState(0);
  const [bananaBeneficiary6to8, setBananaBeneficiary6to8] = useState(0);
  const [remark, setRemark] = useState('');
  const [rows, setRows] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

      const DB_NAME = 'SchoolManagementDB';
    const SCHOOL_STORE = 'schoolData';
    const DB_VERSION = 1;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

    
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  
     const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};

  useEffect(() => {
    fetchSchoolData();
    handleFetchStudentCount(); 
    fetchData();
  }, [udiseNumber]);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);



  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/eggBananaReport.json`);
     
      const data = response.data || {};
      setRows(Object.values(data));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleSave = async () => {
    const newData = {
      selectedDate,
      eggBeneficiary1to5,
      eggBeneficiary6to8,
      bananaBeneficiary1to5,
      bananaBeneficiary6to8,
      remark,
    };

    try {
      await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/eggBananaReport/${selectedDate}.json`, newData);
      setRows([...rows, newData]);
      resetForm();
      setAlertMessage('Data saved successfully!');
    } catch (error) {
      console.error('Error saving data:', error);
      setAlertMessage('Failed to save data.');
    }
  };

  const handleEdit = (index) => {
    const rowToEdit = rows[index];
    setSelectedDate(rowToEdit.selectedDate);
    setEggBeneficiary1to5(rowToEdit.eggBeneficiary1to5);
    setEggBeneficiary6to8(rowToEdit.eggBeneficiary6to8);
    setBananaBeneficiary1to5(rowToEdit.bananaBeneficiary1to5);
    setBananaBeneficiary6to8(rowToEdit.bananaBeneficiary6to8);
    setRemark(rowToEdit.remark);
    setIsEditing(true);
    setEditIndex(index);
  };

  const handleUpdate = async () => {
    const updatedData = {
      selectedDate,
      eggBeneficiary1to5,
      eggBeneficiary6to8,
      bananaBeneficiary1to5,
      bananaBeneficiary6to8,
      remark,
    };

    try {
      await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/eggBananaReport/${selectedDate}.json`, updatedData);
      const updatedRows = [...rows];
      updatedRows[editIndex] = updatedData;
      setRows(updatedRows);
      resetForm();
      setAlertMessage('Data updated successfully!');
    } catch (error) {
      console.error('Error updating data:', error);
      setAlertMessage('Failed to update data.');
    }
  };

  const handleDelete = async (index) => {
    const rowToDelete = rows[index];
    try {
      await axios.delete(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/eggBananaReport/${rowToDelete.selectedDate}.json`);
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);
      setAlertMessage('Data deleted successfully!');
    } catch (error) {
      console.error('Error deleting data:', error);
      setAlertMessage('Failed to delete data.');
    }
  };

  const resetForm = () => {
    setSelectedDate('');
    setEggBeneficiary1to5(0);
    setEggBeneficiary6to8(0);
    setBananaBeneficiary1to5(0);
    setBananaBeneficiary6to8(0);
    setRemark('');
    setIsEditing(false);
    setEditIndex(null);
  };


  const handleFetchStudentCount = async () => {
    try {
      const fetchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
      const response = await axios.get(fetchUrl);
      const studentData = response.data || {};

      if (!studentData) {
        return; 
      }

      let classRange1 = language === 'English' ? ['Class I', 'Class II', 'Class III', 'Class IV', 'Class V'] : ['इयत्ता पहिली', 'इयत्ता दुसरी', 'इयत्ता तिसरी', 'इयत्ता चौथी', 'इयत्ता पाचवी'];
      let classRange2 = language === 'English' ? ['Class VI', 'Class VII', 'Class VIII'] : ['इयत्ता सहावी', 'इयत्ता सातवी', 'इयत्ता आठवी'];

      let countClass1to5 = 0;
      let countClass6to8 = 0;

      Object.values(studentData).forEach((student) => {
        if (student !== null) { 
          const trimmedCurrentClass = student.currentClass.trim();
          if (classRange1.includes(trimmedCurrentClass)) {
            countClass1to5++;
          } else if (classRange2.includes(trimmedCurrentClass)) {
            countClass6to8++;
          }
        }
      });

      setCountTotal1to5(countClass1to5);
      setCountTotal6to8(countClass6to8);
    } catch (error) {
      console.error('Failed to fetch student data:', error);
    }
  };


  const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'long' }; 
    return date.toLocaleDateString(language === 'English' ? 'en-US' : 'mr-IN', options);
  };
  
const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };


  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');

    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
      const schoolName = cloneContent.querySelector('p');
      const otherDetails = cloneContent.querySelectorAll('p');

      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
            p.style.fontWeight = 'normal'; 
          }
        });
  
        if (schoolName) {
          schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`;
        }
  
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write(`
          <html>
            <head>
              <title>Print Modal Content</title>
              <style>
                @page {
                  size: A4 portrait;
                  margin: 3mm;
                }
                body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                }
                .modal-content {
                  margin: 20px;
                }
                thead {
                  background-color: #F0F0F0;
                }
                .tip-style {
                  text-align: center;
                  font-size: 12px;
                  margin-top: 20px;
                }
                  th{
                    border: 0.8px solid black;
                     font-size:14px;
                  }
                .printtd-eggbanana{
                  border: 0.8px solid black;
                  text-align: center;  
                  font-size:13px;
                }
                #month-select {
                  margin-right: -30px;
                }
                .Monthname {
                  margin-left: 20px;
                }
                .Dailyrgposhan {
                  margin-top: 0;
                }
              </style>
            </head>
            <body>
              ${cloneContent.outerHTML}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      } else {
        console.error('Print content not found');
      }
    };
  
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed) and pad
      const year = date.getFullYear(); // Get full year
      return `${day}-${month}-${year}`; // Return formatted date
    };
    return (
      <div> 
        {/* <Sidebar /> */}
        <AlertMessage message={alertMessage} show={showAlert} />
        <div className='main-content-of-page'>
 
        <h3 className='text-center mb-4' style={{ color: '#03365e', fontWeight: '600' }}>
          {language === "English" ? "Egg and Banana Record Book" : "अंडी आणि केळी रजिस्टर"}
        </h3>
        <div style={styles.container}>
     
        <form onSubmit={(e) => { e.preventDefault(); isEditing ? handleUpdate() : handleSave(); }} style={styles.form}>

<div style={styles.formGroup}>
  <div style={styles.inlineGroup}>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language==="English"?'Date':'दिनांक'} :</label>
      <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} required style={{...styles.input, width:'175px'}} />
    </div>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language==="English"?'Remark':'शेरा'} : </label>
      <input type="text" value={remark} onChange={(e) => setRemark(e.target.value)} style={{...styles.input, width:'180px'}} />
    </div>
  </div>
</div>

<div style={styles.formGroup}>
  <div style={styles.inlineGroup}>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language === "English" ? "Egg Beneficiary (1 to 5)" : "अंडी लाभार्थी(१ ते ५)"} : </label>
      <input type="number" value={eggBeneficiary1to5} onChange={(e) => setEggBeneficiary1to5(e.target.value)} required  style={{...styles.input, width:'231px'}} />
    </div>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language === "English" ? "Egg Beneficiary (6 to 8)" : "अंडी लाभार्थी(६ ते ८)"}:</label>
      <input type="number" value={eggBeneficiary6to8} onChange={(e) => setEggBeneficiary6to8(e.target.value)} required  style={{...styles.input, width:'260px'}} />
    </div>
  </div>
</div>

<div style={styles.formGroup}>
  <div style={styles.inlineGroup}>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language === "English" ? "Banana Beneficiary(1 to 5)" : "केळी लाभार्थी(१ ते ५)"} :</label>
      <input type="number" value={bananaBeneficiary1to5} onChange={(e) => setBananaBeneficiary1to5(e.target.value)} required style={{...styles.input, width:'232px'}} />
    </div>
    <div style={styles.inlineField}>
      <label style={styles.label}>{language === "English" ? "Banana Beneficiary(6 to 85)" : "केळी लाभार्थी(६ ते ८)"} :</label>
      <input type="number" value={bananaBeneficiary6to8} onChange={(e) => setBananaBeneficiary6to8(e.target.value)} required style={{...styles.input, width:'260px'}} />
    </div>
  </div>
</div>

<div style={styles.buttonContainer}>
  <button type="submit" style={styles.buttonsave}>{isEditing ? 'Update' : 'Save'}</button>
  <button type="button" onClick={openModal} style={styles.buttondelete}>Report</button>
</div>
</form>
    </div>

      <table style={{margin:'40px auto '}}>
        <thead>
        <tr style={{ color: 'black', padding:'10px' }}>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px', borderTop:'1px solid black' }}>{language === "English" ? "Sr. No" : "क्र."}</th>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px', borderTop:'1px solid black' }}>{language === "English" ? "Day" : "वार"}</th>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto -10px', borderTop:'1px solid black' }}>{language === "English" ? "Date" : "दिनांक"}</th>
                      <th colSpan={3} style={{...thstyle, borderTop:'1px solid black' }}>{language === "English" ? "Students Number" : "पट संख्या"}</th>
                      <th colSpan={3} style={{...thstyle, borderTop:'1px solid black' }}>{language === "English" ? "Egg Beneficiary" : "अंडी लाभार्थी"}</th>
                      <th colSpan={3} style={{...thstyle, borderTop:'1px solid black' }}>{language === "English" ? "Banana Beneficiary" : "केळी लाभार्थी"}</th>
                      <th rowSpan={2} style={{...thstyle, borderLeft:'1px solid black', borderTop:'1px solid black'}}>{language === "English" ? "Total" : "एकूण"}</th>
                      <th rowSpan={2} style={{...thstyle, borderTop:'1px solid black' }}>{language === "English" ? "Remark" : "शेरा"}</th>
                      <th rowSpan={2} style={{...thstyle, borderTop:'1px solid black' }}>Actions</th>
                    </tr>

                    <tr>
                        <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                        <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                        <th style={thstyle}>{language === "English" ? "Total" : "एकूण"}</th>
                        <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                        <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                        <th style={thstyle}>{language === "English" ? "Total" : "एकूण"}</th>
                        <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                        <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                        <th style={{...thstyle}}>{language === "English" ? "Total" : "एकूण"}</th>
                    </tr>
        </thead>
        <tbody>
  {rows.length > 0 ? (
    rows.map((row, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{getDayOfWeek(row.selectedDate)}</td>
        <td>{formatDate(row.selectedDate)}</td>
        <td>{countTotal1to5}</td>
        <td>{countTotal6to8}</td>
        <td>{countTotal1to5 + countTotal6to8}</td>
        <td>{row.eggBeneficiary1to5}</td>
        <td>{row.eggBeneficiary6to8}</td>
        <td>{parseInt(row.eggBeneficiary1to5) + parseInt(row.eggBeneficiary6to8)}</td>
        <td>{row.bananaBeneficiary1to5}</td>
        <td>{row.bananaBeneficiary6to8}</td>
        <td>{parseInt(row.bananaBeneficiary1to5) + parseInt(row.bananaBeneficiary6to8)}</td>

        <td>{parseInt(row.eggBeneficiary1to5) + parseInt(row.eggBeneficiary6to8) + parseInt(row.bananaBeneficiary1to5) + parseInt(row.bananaBeneficiary6to8)}</td>
        <td>{row.remark}</td>
            <td>
                      <button 
                        onClick={() => handleEdit(index)} 
                        style={{ marginRight: '5px', background: '#2196F3', color: '#fff', border: 'none', borderRadius: '3px', padding: '5px' }}>
                        <i className="fa-solid fa-pen-to-square"></i>
                      </button>
                      <button 
                        onClick={() => handleDelete(index)} 
                        style={{ background: '#f44336', color: '#fff', border: 'none', borderRadius: '3px', padding: '5px' }}>
                       <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
    </tr>
  )}
</tbody>
      </table>

          {showModal && (
            <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1000',
          }}>
            <div style={{
              backgroundColor: '#fff',
              padding: '30px',
              borderRadius: '10px',
              width: '80%',
              maxWidth: '800px', // Set a max width for better fitting
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}>



              <div className="modal-content">
                {/* Table for Report Data */}
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginBottom: '30px',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
                    <thead>
                      {schoolData && (
                        <tr>
                          <th colSpan="14" style={{
                            color: 'black',
                            padding: '5px',
                            borderRadius: '10px 10px 0 0',
                            textAlign: 'center',
                            lineHeight: '0.4',
                            borderBottom: '1px solid black',
                            borderLeft: '1px solid black',
                            borderRight: '1px solid black',
                            borderTop: '1px solid black',
                            fontSize: '13px',
                            position: 'relative' 
                          }}>
                            <p><strong><h6>{schoolData.schoolName}</h6></strong></p>
                            <p>{language === "English" ? "Taluka:" : "ता."} {schoolData.taluka}, {language === "English" ? "Jilha:" : "जि. "} {schoolData.jilha}</p>
                            <p className='Dailyrgposhan' style={{ display: 'inline-block', backgroundColor: '#252729', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '14px' }}>
    {language === "English" ? 
        `Eggs / Bananas Record Book` : 
        `अंडी / केळी नोंद वही`}
 
</p>
                        </th>
                      </tr>
                    )}
                    <tr style={{ color: 'black' }}>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px' }}>{language === "English" ? "Sr. No" : "क्र."}</th>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px' }}>{language === "English" ? "Day" : "वार"}</th>
                      <th rowSpan={2}  style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto -10px', width:'190px' }}>{language === "English" ? "Date" : "दिनांक"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "Students Number" : "पट संख्या"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "Egg Beneficiary" : "अंडी लाभार्थी"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "Banana Beneficiary" : "केळी लाभार्थी"}</th>
                      <th rowSpan={2}  style={{...thstyle, borderLeft:'1px solid black'}}>{language === "English" ? "Total" : "एकूण"}</th>
                      <th rowSpan={2}  style={thstyle}>{language === "English" ? "Remark" : "शेरा"}</th>
                    </tr>

                    <tr>
                    <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                    <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                    <th style={thstyle}>{language === "English" ? "Total" : "एकूण"}</th>
                    <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                    <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                    <th style={thstyle}>{language === "English" ? "Total" : "एकूण"}</th>
                    <th style={thstyle}>{language === "English" ? "1 To 5" : "१ ते ५"}</th>
                    <th style={thstyle}>{language === "English" ? "6 To 8" : "६ ते ८"}</th>
                    <th style={thstyle}>{language === "English" ? "Total" : "एकूण"}</th>
                   
                    </tr>
                    <tr>
                    <th style={{...thstyle, fontSize:'12px', borderLeft:'1px solid black'}}>1</th>

                        {Array.from({ length: 13 }, (_, index) => (
                        <th style={{...thstyle, fontSize:'12px'}} key={index}>{index + 2}</th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
  {rows.length > 0 ? (
    rows.map((row, index) => (
      <tr key={index}>
      <td className='printtd-eggbanana'  style={{fontSize:'12px'}}>{index + 1}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{getDayOfWeek(row.selectedDate)}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{formatDate(row.selectedDate)}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{countTotal1to5}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{countTotal6to8}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{countTotal1to5 + countTotal6to8}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{row.eggBeneficiary1to5}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{row.eggBeneficiary6to8}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{parseInt(row.eggBeneficiary1to5) + parseInt(row.eggBeneficiary6to8)}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{row.bananaBeneficiary1to5}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{row.bananaBeneficiary6to8}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{parseInt(row.bananaBeneficiary1to5) + parseInt(row.bananaBeneficiary6to8)}</td>
        <td className='printtd-eggbanana' style={{fontSize:'12px'}}>{parseInt(row.eggBeneficiary1to5) + parseInt(row.eggBeneficiary6to8) + parseInt(row.bananaBeneficiary1to5) + parseInt(row.bananaBeneficiary6to8)}</td>
        <td className='printtd-eggbanana'  style={{fontSize:'12px'}}>{row.remark}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="14" style={{ textAlign: 'center' }}>No data available</td>
    </tr>
  )}
</tbody>
    </table>       
              </div>
              <div style={{ textAlign: 'right', marginTop: '20px' }}>
              
              <button onClick={handlePrint} style={{
                  padding: '12px 20px',
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                  marginRight: '10px'
                }}>
                  Print
                </button>

              <button onClick={closeModal} style={{
                  padding: '12px 20px',
                  backgroundColor: '#FF4136',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#E04A3F'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#FF4136'}
                >
               {language === "English" ? "Close" : " बंद करा"}                          
                </button>

              </div>
            </div>
          </div>
        )}
<style jsx>{`
td{
  padding: 10px 5px;
  border:1px solid black;
}
`}</style>
      </div>
    </div>
  );
  
}

export default EggandBananaRegisterBook;

// Internal CSS styles
const styles = {
    container: {
      maxWidth: '630px', // Set a smaller width for the form
      margin: '0 auto 20px auto', // Center the form
      padding: '25px 20px 25px 30px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#f9f9f9',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    formGroup: {
      display: 'flex', // Use flexbox to align label and input in one line
      alignItems: 'center', // Center align items vertically
      marginBottom: '20px',
    },
    label: {
      marginRight: '10px', // Space between label and input
      fontWeight: 'bold',
      flex: '0 0 350px', // Fixed width for the label
    },
    input: {
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      width: '100%',
      height:'34px',
      boxSizing: 'border-box',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    buttonsave: {
      padding: '6px 12px',
      border: 'none',
      borderRadius: '4px',
      backgroundColor: 'rgb(76, 175, 80)',
      color: '#fff',
      cursor: 'pointer',
      transition: 'background-color 0.3 s',
    },
    buttondelete: {
      padding: '6px 12px',
      border: 'none',
      borderRadius: '4px',
      backgroundColor: 'rgb(212, 160, 23)',
      color: '#fff',
      cursor: 'pointer',
      transition: 'background-color 0.3 s',
    },
    inlineGroup: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
},
inlineField: {
  flex: '1',
  marginRight: '10px',
},
inlineFieldLast: {
  marginRight: '0',
},
  };
// Style objects
const thstyle = {
  fontSize: '14px',
  padding: '6px',
  fontWeight: '600',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
  width: '60px', color:'black'
}
